/* eslint-disable jsx-a11y/anchor-is-valid */

/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

import { Grid } from '@material-ui/core';

import { CardLogin } from '../../CardLogin';
import { useStyles } from '../../styles';

function CardLoginForm({ isNaoCorrentista = false, gtm }) {
  const classes = useStyles({ isNaoCorrentista });

  return (
    <Grid
      item
      container
      alignItems="center"
      direction="column"
      className={classes.container}
    >
      <CardLogin gtm={gtm} isNaoCorrentista={isNaoCorrentista} isSingleCard />
    </Grid>
  );
}

export default CardLoginForm;
